import axios from "axios";
import React, { useEffect, useState } from "react";
import { server } from "../../server";
import { toast } from "react-toastify";
import { useLocation, useNavigate } from "react-router-dom";
import PageName from "../../Components/global/PageName";
import { Paper } from "@mui/material";

export default function Doc() {
  const navigate = useNavigate();
  const [docDetails, setDocDetails] = useState("");
  const location = useLocation();
  const docId = location.state?.docId || null;

  useEffect(() => {
    getDocumentDetails();
  }, []);

  const getDocumentDetails = async () => {
    try {
      if (!docId) return null;
      const { data } = await axios.get(`${server}/docs/getById`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        params: {
          docsId: docId || null,
        },
      });

      setDocDetails(data?.data);
    } catch (e) {
      toast.error(e?.response?.data || e.response);
    }
  };

  return (
    <div>
      <PageName
        title={docDetails?.title}
        button
        buttonTitle="Edit Document"
        buttonOnClick={() =>
          navigate("../editDoc", { state: { docId: docDetails?.id } })
        }
      />
      <Paper className="p-4" sx={{ mt: 2 }}>
        <div
          dangerouslySetInnerHTML={{ __html: docDetails.content || "---" }}
        />
      </Paper>
    </div>
  );
}
